"use client";

import classNames from "classnames";
import { FC, MouseEvent, useEffect, useRef, useState } from "react";
import { Swiper as SwiperType } from "swiper";
// import "swiper/css";
import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";

import AnchorLink from "@/components/ui/AnchorLink/AnchorLink";
import Icon from "@/components/ui/Icon/Icon";
import useMediaQuery from "@/hooks/useMediaQuery";

import ChooseCardGallery from "./ChooseCardGallery";
import "./TabGallery.css";
import { TabbedCarouselData } from "./type";

const TabGallery: FC<TabbedCarouselData> = ({ entry }) => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  const tabSwiperRef = useRef<SwiperType | null>(null);
  const cardSwiperRef = useRef<SwiperType | null>(null);

  const justClicked = useRef(false);

  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabClick = (themeIndex: number): void => {
    setActiveTabIndex(themeIndex);
    if (cardSwiperRef.current) {
      justClicked.current = true;
      cardSwiperRef.current.slideTo(getFirstSlideIndex(themeIndex));
      setTimeout(() => (justClicked.current = false), 100);
    }
  };

  const getFirstSlideIndex = (themeIndex: number): number => {
    let index = 0;
    for (let i = 0; i < themeIndex; i++) {
      index += entry.amenities[i].columns.length;
    }
    return index;
  };

  const handleCardSlideChange = (swiper: SwiperType): void => {
    if (justClicked.current) {
      return;
    }
    const realIndex = swiper.realIndex;
    let currentIndex = 0;

    for (let i = 0; i < entry.amenities.length; i++) {
      currentIndex += entry.amenities[i].columns.length;
      if (realIndex < currentIndex) {
        setActiveTabIndex(i);
        if (tabSwiperRef.current) {
          tabSwiperRef.current.slideTo(i);
        }
        break;
      }
    }
  };

  return (
    <div
      className="flex flex-col items-end w-full md:pm-0"
      style={{ backgroundColor: entry.backgroundColor ?? undefined, color: entry.textColor ?? undefined }}
    >
      <div className="w-full h-full">
        <div className="w-full text-center py-xxl">
          <h2 className="accent-font accent-title accent-color font-primary uppercase text-l md:text-xl p-m">{entry.title}</h2>
        </div>
        <div className="w-full pb-l md:pb-xxl md:pl-[10vw] md:pr-[10vw] tab-gallery-swiper">
          <Swiper
            onSwiper={(swiper) => (tabSwiperRef.current = swiper)}
            className="w-full"
            slidesPerView={4.4}
            breakpoints={{
              1024: {
                slidesPerView: 7,
              },
            }}
            spaceBetween={10}
          >
            {entry.amenities.map((amenity, index) => (
              <SwiperSlide key={index}>
                {amenity.labelIcon && (
                  <button
                    className={classNames("w-[68px] mx-auto md:w-[135px] flex flex-col items-center text-gray-30 text-center tab-button", {
                      active: activeTabIndex == index,
                    })}
                    onClick={() => handleTabClick(index)}
                  >
                    <div className={`icon-content group-${index}`} data-length={amenity.columns.length.toString()}>
                      {amenity.labelIcon.link?.icon && (
                        <>
                          <div className="hidden md:block">
                            <Icon className="stroke-gray-20" name={amenity.labelIcon.link?.icon} size="48" title={amenity.labelIcon.label} />
                          </div>
                          <div className="md:hidden">
                            <Icon className="stroke-gray-20" name={amenity.labelIcon.link?.icon} size="32" title={amenity.labelIcon.label} />
                          </div>
                        </>
                      )}
                    </div>
                    <div className={`icon-text font-secondary font-medium text-s uppercase py-xs text-center`}>{amenity.labelIcon.label}</div>
                  </button>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="w-full h-fix-tab-card mb-xxl image-gallery-swiper">
          <Swiper
            key="card-swiper"
            onSwiper={(swiper) => (cardSwiperRef.current = swiper)}
            slidesPerView={"auto"}
            // autoHeight
            spaceBetween={isDesktop ? 24 : 16}
            onSlideChange={(swiper) => handleCardSlideChange(swiper)}
          >
            {entry.amenities.map((amenity, indexGroup) =>
              amenity.columns.map((column, index) => (
                <SwiperSlide className="!w-fit" key={index} data-slide={indexGroup}>
                  <ChooseCardGallery column={column} />
                </SwiperSlide>
              )),
            )}
          </Swiper>
        </div>
      </div>
    </div>
  );
};
export default TabGallery;
